import { Icon, Spreader, Text } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

import styles from './Highlighted.module.scss'

export const Highlighted = () => {
  const { t } = useTranslation()

  return (
    <Row className={styles.highlighted} vertical='center' horizontal='center'>
      <Icon icon='icon-star' color='white' size={12} />

      <Spreader spread={5} />

      <Text size={12} weight={600} color='white' lineHeight='normal'>
        {t('checkout.plans.plan.panel.highlighted')}
      </Text>
    </Row>
  )
}

Highlighted.displayName = 'CheckoutPlansPlanPanelsPlanHighlighted'
